// Legacy build-time tenant configuration.
//
// Runtime-aware code must use TenantProvider/useTenant instead. This value is
// retained only while existing per-tenant builds are migrated. Deliberately do
// not provide a default tenant: a missing tenant must fail explicitly rather
// than leaking requests into another business.
const configuredWebsiteId = process.env.REACT_APP_WEBSITE_ID?.trim();

export const LEGACY_WEBSITE_ID: string | undefined = configuredWebsiteId || undefined;

/** @deprecated Use useTenant() or pass a tenantId explicitly. */
export const WEBSITE_ID = LEGACY_WEBSITE_ID ?? '';

export const getLegacyWebsiteId = (): string | undefined => LEGACY_WEBSITE_ID;
